import * as React from 'react';

import IconCollectionsAdd from './IconCollectionsAdd';

export const collectionsAdd = () => <IconCollectionsAdd />;

export default {
    title: 'Icons/Collections/Add',
    component: IconCollectionsAdd,
    parameters: {
        notes: "`import IconCollectionsAdd from 'box-ui-elements/es/icons/collection/IconCollectionsAdd';`",
    },
};
